import styled from "styled-components";
import { color, font } from "shared/utils/styles";
import BreakPoints from "shared/utils/Breakpoint";
import breakpoints from "shared/utils/breakpoints";

type BoxPropT = {
  isActive?: boolean;
  variant?: string;
};

export const Container = styled.div`
  padding-top: 50px;
`;

export const FormTitle = styled.div`
  ${font.size(24)}
  font-weight: 550;
  line-height: 28.13px;
  letter-spacing: -0.025em;
  text-align: left;
  padding: 20px;
`;

export const FormContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  flex-direction: column;
  padding: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  width: 40%;
`;

export const InputLabel = styled.div`
  ${font.size(16)}
  font-weight: 400;
  line-height: 18.75px;
  text-align: left;
`;

export const Button = styled.button<BoxPropT>`
  border-radius: 0.4rem;
  width: 166px;
  color: #fff;
  background: ${(props) => props.variant || color.fountain};
  // padding: 1rem 2rem;
  height: 55px;
  margin-bottom: 20px;
  cursor: pointer;
  margin-left: 20px;
  margin-top: 20px;
  :hover {
    background: ${color.fountainAccent};
  }
`;
